module.exports = __webpack_public_path__ + "img/join_content_2__slider_2.dc598ae8.png";